import { useCallback, useState } from 'react';

function useCameraGuidance() {
  const [isShowGuidance, setIsShowGuidance] = useState(false);

  const onCloseGuidance = useCallback(() => {
    setIsShowGuidance(false);
  }, []);

  const onOpenGuidance = useCallback(() => {
    setIsShowGuidance(true);
  }, []);

  return { onCloseGuidance, onOpenGuidance, isShowGuidance };
}

export default useCameraGuidance;
